module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_22-045f282272340c6a0fdb2ba15de5ff92.jpg";